module.exports = __webpack_public_path__ + "static/media/2025_60N.59a0a81c.pdf";